<!-- Ported from the Polaris kit: src/components/ui/range-calendar/RangeCalendarCell.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
     Change the design in the kit first, then re-port.
     Hand change (phase 7.1): `rounded-l-md`/`rounded-r-md` → `rounded-l-polaris-md`/`rounded-r-polaris-md` (the porter only
     maps the plain `rounded-md` to the kit's radius scale). -->
<script setup>
import { reactiveOmit } from '@vueuse/core';
import { RangeCalendarCell, useForwardProps } from 'reka-ui';
import { cn } from '../../lib/utils';

const props = defineProps({
  date: { type: Object, required: true },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: {
    type: [Boolean, null, String, Object, Array],
    required: false,
    skipCheck: true,
  },
});

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
  <RangeCalendarCell
    data-slot="range-calendar-cell"
    :class="
      cn(
        'relative p-0 text-center type-polaris-body focus-within:relative focus-within:z-20 [&:has([data-selected])]:bg-polaris-accent first:[&:has([data-selected])]:rounded-l-polaris-md last:[&:has([data-selected])]:rounded-r-polaris-md [&:has([data-selected][data-selection-end])]:rounded-r-polaris-md [&:has([data-selected][data-selection-start])]:rounded-l-polaris-md',
        props.class
      )
    "
    v-bind="forwardedProps"
  >
    <slot />
  </RangeCalendarCell>
</template>
